/* ═══════════════════════════════════════════════════════════════════════════
   MSC ON THE RISE — Complete Interactions
   IIFE — vanilla JS, no dependencies
   Pattern: msc-partners.js
   ═══════════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var ROOT_SEL = '.msc-otr';
  var CARD_SEL = '.msc-otr__card';

  var root = document.querySelector(ROOT_SEL);
  if (!root) return;

  var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── HELPERS ────────────────────────────────────────────────────────────

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function escapeAttr(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // ── MODULE 1: FILTERS ─────────────────────────────────────────────────

  function initFilters() {
    var filterBar = root.querySelector('.msc-otr__filter-bar');
    if (!filterBar) return;

    var chips = filterBar.querySelectorAll('.msc-otr__filter-chip');
    var cards = root.querySelectorAll(CARD_SEL);
    var shownEl = root.querySelector('[data-filter-shown]');
    var totalEl = root.querySelector('[data-filter-total]');
    var emptyEl = root.querySelector('[data-empty-state]');
    var gridLabel = root.querySelector('[data-grid-label]');
    var activeFilters = [];

    var ageGroups = ['15-16', '17-18'];
    var genders = ['F', 'M'];
    var disciplines = ['xc', 'enduro', 'dh', 'short-track'];

    function applyFilters() {
      var visibleCount = 0;
      var staggerIdx = 0;

      cards.forEach(function (card) {
        if (activeFilters.length === 0) {
          card.classList.remove('is-hidden');
          if (!reducedMotion) {
            card.style.animationDelay = (staggerIdx * 0.08) + 's';
          }
          visibleCount++;
          staggerIdx++;
          return;
        }

        var category = card.getAttribute('data-category');
        var gender = card.getAttribute('data-gender');
        var disciplinePrimary = card.getAttribute('data-discipline-primary');
        var match = true;

        activeFilters.forEach(function (f) {
          if (ageGroups.indexOf(f) !== -1 && category !== f) match = false;
          if (genders.indexOf(f) !== -1 && gender !== f) match = false;
          if (disciplines.indexOf(f) !== -1 && disciplinePrimary !== f) match = false;
        });

        if (match) {
          card.classList.remove('is-hidden');
          if (!reducedMotion) {
            card.style.animationDelay = (staggerIdx * 0.08) + 's';
          }
          visibleCount++;
          staggerIdx++;
        } else {
          card.classList.add('is-hidden');
        }
      });

      if (shownEl) shownEl.textContent = visibleCount;
      if (emptyEl) emptyEl.style.display = visibleCount === 0 ? '' : 'none';
      if (gridLabel) {
        gridLabel.textContent = activeFilters.length === 0 ? 'All Riders' : 'Filtered Results';
      }
    }

    function syncNavStrip() {
      var stripItems = root.querySelectorAll('.msc-otr__rider-strip-item');
      if (stripItems.length === 0) return;

      stripItems.forEach(function (item) {
        if (activeFilters.length === 0) {
          item.style.display = '';
          return;
        }

        var cat = item.getAttribute('data-category');
        var gen = item.getAttribute('data-gender');
        var disc = item.getAttribute('data-discipline-primary');
        var match = true;

        activeFilters.forEach(function (f) {
          if (ageGroups.indexOf(f) !== -1 && cat !== f) match = false;
          if (genders.indexOf(f) !== -1 && gen !== f) match = false;
          if (disciplines.indexOf(f) !== -1 && disc !== f) match = false;
        });

        item.style.display = match ? '' : 'none';
      });
    }

    function updateChips() {
      chips.forEach(function (chip) {
        var val = chip.getAttribute('data-filter');
        if (val === 'all') {
          chip.classList.toggle('is-active', activeFilters.length === 0);
        } else {
          chip.classList.toggle('is-active', activeFilters.indexOf(val) !== -1);
        }
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var val = chip.getAttribute('data-filter');

        if (val === 'all') {
          activeFilters = [];
        } else if (ageGroups.indexOf(val) !== -1) {
          var withoutAge = activeFilters.filter(function (f) { return ageGroups.indexOf(f) === -1; });
          if (activeFilters.indexOf(val) !== -1) {
            activeFilters = withoutAge;
          } else {
            activeFilters = withoutAge.concat([val]);
          }
        } else if (genders.indexOf(val) !== -1) {
          var withoutGender = activeFilters.filter(function (f) { return genders.indexOf(f) === -1; });
          if (activeFilters.indexOf(val) !== -1) {
            activeFilters = withoutGender;
          } else {
            activeFilters = withoutGender.concat([val]);
          }
        } else if (disciplines.indexOf(val) !== -1) {
          var withoutDisc = activeFilters.filter(function (f) { return disciplines.indexOf(f) === -1; });
          if (activeFilters.indexOf(val) !== -1) {
            activeFilters = withoutDisc;
          } else {
            activeFilters = withoutDisc.concat([val]);
          }
        }

        updateChips();
        applyFilters();
        syncNavStrip();
      });
    });
  }

  // ── MODULE 2: CARDS ───────────────────────────────────────────────────

  function initCards() {
    if (isTouch || reducedMotion) return;

    var cards = root.querySelectorAll(CARD_SEL);

    cards.forEach(function (card) {
      var shine = card.querySelector('.msc-otr__card-shine');

      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var xPct = ((e.clientX - rect.left) / rect.width) * 100;
        var yPct = ((e.clientY - rect.top) / rect.height) * 100;

        // Light follow
        if (shine) {
          shine.style.background = 'radial-gradient(circle at ' + xPct + '% ' + yPct + '%, rgba(200,16,46,0.06) 0%, transparent 50%)';
        }

        // Perspective tilt
        var rotateY = ((xPct - 50) * 0.12);
        var rotateX = ((yPct - 50) * -0.12);
        card.style.transform = 'perspective(800px) rotateY(' + rotateY + 'deg) rotateX(' + rotateX + 'deg) translateY(-4px)';
        card.style.transition = 'border-color 0.3s, transform 0.08s ease, box-shadow 0.3s';
      });

      card.addEventListener('mouseleave', function () {
        if (shine) {
          shine.style.background = '';
        }
        card.style.transform = '';
        card.style.transition = '';
      });
    });
  }

  // ── MODULE 3: OVERLAY ─────────────────────────────────────────────────

  var overlayEl = null;
  var previousFocus = null;

  function getVisibleCards() {
    var all = root.querySelectorAll(CARD_SEL);
    var visible = [];
    all.forEach(function (c) {
      if (!c.classList.contains('is-hidden')) visible.push(c);
    });
    return visible;
  }

  function findCardById(riderId) {
    return root.querySelector(CARD_SEL + '[data-rider-id="' + riderId + '"]');
  }

  function buildOverlayHtml(card) {
    var d = card.dataset;
    var name = escapeHtml(d.name);
    var lastName = escapeHtml(d.lastName) || name;
    var heroInfo1 = escapeHtml(d.heroInfo1) || '';
    var heroInfo2 = escapeHtml(d.heroInfo2) || '';
    var heroInfo3 = escapeHtml(d.heroInfo3) || '';
    var cutout = d.cutout || '';
    var nickname = escapeHtml(d.nickname);
    var age = escapeHtml(d.age);
    var hometown = escapeHtml(d.hometown);
    var category = escapeHtml(d.category);
    var gender = d.gender;
    var discipline = escapeHtml(d.discipline);
    var discPrimary = d.disciplinePrimary || 'xc';
    var team = d.team ? escapeHtml(d.team) : 'Privateer';
    var portrait = d.portrait || '';
    var wins = escapeHtml(d.wins);
    var podiums = escapeHtml(d.podiums);
    var seasonRank = escapeHtml(d.seasonRank);
    var seasonsOtr = escapeHtml(d.seasonsOtr);
    var riderNumber = escapeHtml(d.riderNumber) || seasonRank;
    var accentColor = d.accentColor || '';

    var genderLabel = gender === 'F' ? 'Women' : 'Men';

    // Build inline style for overlay accent color
    var overlayStyle = '';
    if (accentColor) overlayStyle += '--rider-accent:' + accentColor + ';';

    var html = '';

    // ═══ D1: HERO (F1-STYLE) ════════════════════════════════════════════════

    html += '<div class="msc-otr__overlay-hero msc-otr__overlay-hero--' + escapeAttr(discPrimary) + '" style="' + overlayStyle + '">';

    // Background layers (gradient only — no background image, matching F1)
    html += '<div class="msc-otr__overlay-hero-fade"></div>';
    html += '<div class="msc-otr__overlay-hero-grain"></div>';

    // Giant rider number watermark (behind cutout, like F1's "44")
    if (riderNumber) {
      html += '<div class="msc-otr__overlay-hero-watermark" aria-hidden="true">' + riderNumber + '</div>';
    }

    // ← ALL RIDERS back link
    html += '<button class="msc-otr__overlay-back" data-overlay-close aria-label="Back to all riders">\u2190 ALL RIDERS</button>';

    // Close button
    html += '<button class="msc-otr__overlay-close" data-overlay-close aria-label="Close profile">\u2715</button>';

    // Rider number badge (top-right)
    if (riderNumber) {
      html += '<div class="msc-otr__overlay-hero-number" aria-hidden="true">' + riderNumber + '</div>';
    }

    // Left side: vertical stripes + name + info line
    html += '<div class="msc-otr__overlay-hero-info" data-parallax-info>';

    // First name (italic) + Last name (massive bold uppercase)
    html += '<div class="msc-otr__overlay-hero-name-block">';
    html += '<div class="msc-otr__overlay-hero-firstname">' + name + '</div>';
    html += '<h2 class="msc-otr__overlay-hero-name">' + lastName + '</h2>';
    html += '</div>';

    // F1-style info line: Hometown | Team | Age
    var metaParts = [hometown, team, age].filter(function(s) { return s; });
    if (metaParts.length) {
      html += '<div class="msc-otr__overlay-hero-meta">';
      metaParts.forEach(function(part, i) {
        if (i > 0) html += '<span class="msc-otr__overlay-hero-pipe">|</span>';
        html += '<span>' + part + '</span>';
      });
      html += '</div>';
    }

    html += '</div>'; // end hero-info

    // Right side: cutout PNG (or portrait fallback)
    if (cutout || portrait) {
      html += '<div class="msc-otr__overlay-hero-cutout">';
      html += '<img src="' + escapeAttr(cutout || portrait) + '" alt="' + escapeAttr(d.name) + ' ' + escapeAttr(d.lastName || '') + '">';
      html += '</div>';
    }

    html += '</div>'; // end hero

    // ═══ D2: PROMOTED QUOTE ═════════════════════════════════════════════════
    if (d.bigQuote) {
      html += '<div class="msc-otr__overlay-quote-hero" style="' + overlayStyle + '">';
      html += '<p class="msc-otr__overlay-quote-hero-text">\u201C' + escapeHtml(d.bigQuote) + '\u201D</p>';
      html += '<div class="msc-otr__overlay-quote-hero-attr">\u2014 ' + name + '</div>';
      html += '</div>';
    }

    // ═══ TAB BAR ════════════════════════════════════════════════════════════
    html += '<div class="msc-otr__overlay-tabs">';
    html += '<button class="msc-otr__overlay-tab-btn is-active" data-tab-target="stats">Stats</button>';
    html += '<button class="msc-otr__overlay-tab-btn" data-tab-target="story">Bio</button>';
    html += '</div>';

    // ═══ STATS TAB ══════════════════════════════════════════════════════════
    html += '<div class="msc-otr__overlay-tab is-active" data-tab="stats">';

    // ═══ RIDER CARD (structured data block) ═════════════════════════════════
    var riderCardItems = [
      { lbl: 'Age', val: age },
      { lbl: 'Hometown', val: hometown },
      { lbl: 'Team', val: team },
      { lbl: 'Discipline', val: discipline },
      { lbl: 'Years Racing', val: d.yearsRacing ? escapeHtml(d.yearsRacing) : '' },
      { lbl: 'Season Rank', val: seasonRank ? '#' + seasonRank : '' }
    ];
    var hasRiderCard = riderCardItems.some(function (item) { return item.val; });
    if (hasRiderCard) {
      html += '<div class="msc-otr__overlay-section" data-section="rider-card">';
      html += '<div class="msc-otr__overlay-section-label">Rider Card</div>';
      html += '<div class="msc-otr__overlay-setup">';
      riderCardItems.forEach(function (item) {
        if (item.val) {
          html += '<div class="msc-otr__overlay-setup-item">';
          html += '<div class="msc-otr__overlay-setup-label">' + item.lbl + '</div>';
          html += '<div class="msc-otr__overlay-setup-value">' + item.val + '</div>';
          html += '</div>';
        }
      });
      html += '</div></div>';
    }

    // ═══ D3: THIS SEASON ════════════════════════════════════════════════════
    var hasSeasonData = wins || podiums || seasonRank || d.seasonResults;
    if (hasSeasonData) {
      html += '<div class="msc-otr__overlay-section" data-section="this-season">';
      html += '<div class="msc-otr__overlay-section-label">This Season</div>';

      // Stats summary row
      var seasonStats = [
        { val: wins, lbl: 'Wins' },
        { val: podiums, lbl: 'Podiums' },
        { val: seasonRank, lbl: 'Season Rank' }
      ];
      var hasAnyStat = seasonStats.some(function (s) { return s.val; });
      if (hasAnyStat) {
        html += '<div class="msc-otr__overlay-stats" data-stats-bar>';
        seasonStats.forEach(function (s) {
          if (s.val) {
            html += '<div class="msc-otr__overlay-stat">';
            html += '<div class="msc-otr__overlay-stat-value">' + s.val + '</div>';
            html += '<div class="msc-otr__overlay-stat-label">' + s.lbl + '</div>';
            html += '</div>';
          }
        });
        html += '</div>';
      }

      // Season results table
      if (d.seasonResults) {
        html += '<div class="msc-otr__overlay-result-table">';
        html += '<div class="msc-otr__overlay-result-header">';
        html += '<div class="msc-otr__overlay-result-header-cell">Race</div>';
        html += '<div class="msc-otr__overlay-result-header-cell">Position</div>';
        html += '<div class="msc-otr__overlay-result-header-cell">Category</div>';
        html += '</div>';
        var rows = d.seasonResults.split('\n');
        rows.forEach(function (row) {
          var parts = row.split('|');
          if (parts.length >= 3) {
            var race = parts[0].trim();
            var position = parts[1].trim();
            var cat = parts[2].trim();
            var posClass = 'msc-otr__overlay-result-position';
            if (position === '1st') posClass += ' msc-otr__overlay-result-position--first';
            if (position === 'DNF') posClass += ' msc-otr__overlay-result-position--dnf';
            html += '<div class="msc-otr__overlay-result-row">';
            html += '<div class="msc-otr__overlay-result-race">' + escapeHtml(race) + '</div>';
            html += '<div class="' + posClass + '">' + escapeHtml(position) + '</div>';
            html += '<div class="msc-otr__overlay-result-category">' + escapeHtml(cat) + '</div>';
            html += '</div>';
          }
        });
        html += '</div>';
      }

      html += '</div>';
    }

    // ═══ D4: SEASON OUTLOOK (moved from News tab) ══════════════════════════
    if (d.targetRaces || d.rivalry || d.projection) {
      html += '<div class="msc-otr__overlay-section" data-section="outlook">';
      html += '<div class="msc-otr__overlay-section-label">Season Outlook</div>';
      html += '<div class="msc-otr__overlay-outlook">';
      if (d.targetRaces) {
        html += '<div class="msc-otr__overlay-outlook-card">';
        html += '<div class="msc-otr__overlay-outlook-card-label">Target Races</div>';
        html += '<div class="msc-otr__overlay-outlook-card-text msc-otr__overlay-outlook-card-text--list">';
        d.targetRaces.split(',').forEach(function (r) {
          var trimmed = r.trim();
          if (trimmed) html += '<span>' + escapeHtml(trimmed) + '</span>';
        });
        html += '</div></div>';
      }
      if (d.rivalry) {
        html += '<div class="msc-otr__overlay-outlook-card">';
        html += '<div class="msc-otr__overlay-outlook-card-label">Rivalry to Watch</div>';
        html += '<div class="msc-otr__overlay-outlook-card-text">' + escapeHtml(d.rivalry) + '</div>';
        html += '</div>';
      }
      if (d.projection) {
        html += '<div class="msc-otr__overlay-outlook-card msc-otr__overlay-outlook-card--full">';
        html += '<div class="msc-otr__overlay-outlook-card-label">MSC Projection</div>';
        html += '<div class="msc-otr__overlay-outlook-projection">' + escapeHtml(d.projection) + '</div>';
        html += '</div>';
      }
      html += '</div></div>';
    }

    // ═══ STOCK WATCH (moved from News tab) ════════════════════════════════
    if (d.stockStatus && d.stockStatus !== 'none' && d.stockBlurb) {
      var stockClass = d.stockStatus === 'up' ? 'msc-otr__overlay-stock--up' : 'msc-otr__overlay-stock--watch';
      var stockIcon = d.stockStatus === 'up' ? '\u25B2' : '\u25C6';
      var stockLabel = d.stockStatus === 'up' ? 'Stock Up' : 'One to Watch';
      html += '<div class="msc-otr__overlay-section">';
      html += '<div class="msc-otr__overlay-stock ' + stockClass + '">';
      html += '<div class="msc-otr__overlay-stock-icon">' + stockIcon + ' ' + stockLabel + '</div>';
      html += '<p class="msc-otr__overlay-stock-blurb">' + escapeHtml(d.stockBlurb) + '</p>';
      html += '</div></div>';
    }

    html += '</div>'; // end stats tab

    // ═══ BIO TAB ═══════════════════════════════════════════════════════════
    html += '<div class="msc-otr__overlay-tab" data-tab="story">';

    // ═══ D5: BIOGRAPHY (F1-style: photo left + text right) ═══════════════
    var hasStory = d.bio || d.extQuote;
    var bioPhoto = d.actionPhoto || portrait || cutout || '';
    if (hasStory) {
      html += '<div class="msc-otr__overlay-section" data-section="the-story">';
      html += '<div class="msc-otr__overlay-section-label">Biography</div>';

      // Two-column layout: photo | bio text
      html += '<div class="msc-otr__overlay-bio-layout">';

      // Left column: portrait photo
      if (bioPhoto) {
        html += '<div class="msc-otr__overlay-bio-photo">';
        html += '<img src="' + escapeAttr(bioPhoto) + '" alt="' + escapeAttr(d.name) + ' ' + escapeAttr(d.lastName || '') + '">';
        html += '</div>';
      }

      // Right column: bio text
      html += '<div class="msc-otr__overlay-bio-text">';
      if (d.bio) {
        html += '<div class="msc-otr__overlay-bio">';
        var paragraphs = d.bio.split('|');
        paragraphs.forEach(function (p) {
          var trimmed = p.trim();
          if (trimmed) html += '<p>' + escapeHtml(trimmed) + '</p>';
        });
        html += '</div>';
      }
      html += '</div>';

      html += '</div>'; // end bio-layout

      if (d.extQuote) {
        html += '<div class="msc-otr__overlay-ext-quote">';
        html += '<p class="msc-otr__overlay-ext-quote-text">\u201C' + escapeHtml(d.extQuote) + '\u201D</p>';
        if (d.extQuoteAuthor) {
          html += '<div class="msc-otr__overlay-ext-quote-attr">\u2014 ' + escapeHtml(d.extQuoteAuthor) + '</div>';
        }
        html += '</div>';
      }
      html += '</div>';
    }

    html += '</div>'; // end bio tab (part 1)

    // ═══ BIO TAB (continued) ════════════════════════════════════════════════
    html += '<div class="msc-otr__overlay-tab msc-otr__overlay-tab--story-cont" data-tab="story">';

    // ═══ D7: THE SETUP ══════════════════════════════════════════════════════
    var setupItems = [
      { lbl: 'Riding Style', val: d.ridingStyle },
      { lbl: 'Home Trail', val: d.homeTrail },
      { lbl: 'Team', val: team },
      { lbl: 'Bike', val: d.bike },
      { lbl: 'Years Racing', val: d.yearsRacing },
      { lbl: 'Goals', val: d.goals }
    ];
    var hasSetup = setupItems.some(function (s) { return s.val; });
    if (hasSetup) {
      html += '<div class="msc-otr__overlay-section" data-section="the-setup">';
      html += '<div class="msc-otr__overlay-section-label">The Setup</div>';
      html += '<div class="msc-otr__overlay-setup">';
      setupItems.forEach(function (item) {
        html += '<div class="msc-otr__overlay-setup-item">';
        html += '<div class="msc-otr__overlay-setup-label">' + item.lbl + '</div>';
        html += '<div class="msc-otr__overlay-setup-value">' + escapeHtml(item.val || '') + '</div>';
        html += '</div>';
      });
      html += '</div></div>';
    }

    // ═══ D8: PHOTO GALLERY (slider beneath bio) ═════════════════════════════
    var hasVideo = d.video;
    var galleryPhotos = [];
    if (d.actionPhoto) galleryPhotos.push(d.actionPhoto);
    if (d.gallery1) galleryPhotos.push(d.gallery1);
    if (d.gallery2) galleryPhotos.push(d.gallery2);
    if (d.gallery3) galleryPhotos.push(d.gallery3);

    if (hasVideo || galleryPhotos.length > 0) {
      html += '<div class="msc-otr__overlay-section" data-section="media">';
      html += '<div class="msc-otr__overlay-section-label">Photos &amp; Media</div>';

      // Video embed
      if (hasVideo) {
        var videoId = '';
        var ytMatch = d.video.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/);
        if (ytMatch) videoId = ytMatch[1];

        if (videoId) {
          html += '<div class="msc-otr__overlay-video-embed" data-video-id="' + videoId + '">';
          html += '<img class="msc-otr__overlay-video-poster" src="https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg" alt="Video thumbnail">';
          html += '<button class="msc-otr__overlay-video-play-btn" data-play-video aria-label="Play video">';
          html += '<div class="msc-otr__overlay-video-play-icon"></div>';
          html += '</button></div>';
        } else {
          html += '<a href="' + escapeAttr(d.video) + '" target="_blank" rel="noopener" class="msc-otr__overlay-video">';
          html += '<div class="msc-otr__overlay-video-play">';
          html += '<div class="msc-otr__overlay-video-play-icon"></div>';
          html += '<div class="msc-otr__overlay-video-label">Watch Video</div>';
          html += '</div></a>';
        }
      }

      // Gallery with thumbnail strip
      if (galleryPhotos.length > 0) {
        html += '<div class="msc-otr__overlay-gallery-wrap">';
        html += '<div class="msc-otr__overlay-gallery-count">' + galleryPhotos.length + ' photo' + (galleryPhotos.length > 1 ? 's' : '') + '</div>';
        html += '<div class="msc-otr__overlay-gallery-featured">';
        html += '<img src="' + escapeAttr(galleryPhotos[0]) + '" alt="' + escapeAttr(d.name) + '" data-gallery-main>';
        html += '</div>';
        if (galleryPhotos.length > 1) {
          html += '<div class="msc-otr__overlay-gallery-strip">';
          galleryPhotos.forEach(function (src, idx) {
            html += '<button class="msc-otr__overlay-gallery-thumb' + (idx === 0 ? ' is-active' : '') + '" data-gallery-idx="' + idx + '" data-gallery-src="' + escapeAttr(src) + '">';
            html += '<img src="' + escapeAttr(src) + '" alt="" loading="lazy">';
            html += '</button>';
          });
          html += '</div>';
        }
        html += '</div>';
      }

      html += '</div>';
    }

    // ═══ SOCIAL LINKS ═══════════════════════════════════════════════════════
    if (d.instagram || d.tiktok) {
      html += '<div class="msc-otr__overlay-section">';
      html += '<div class="msc-otr__overlay-social">';
      if (d.instagram) {
        html += '<a href="https://instagram.com/' + escapeAttr(d.instagram) + '" target="_blank" rel="noopener">@' + escapeHtml(d.instagram) + '</a>';
      }
      if (d.tiktok) {
        html += '<a href="https://tiktok.com/@' + escapeAttr(d.tiktok) + '" target="_blank" rel="noopener">@' + escapeHtml(d.tiktok) + '</a>';
      }
      html += '</div></div>';
    }

    html += '</div>'; // end bio tab (part 2)

    return html;
  }

  function buildNavHtml(visibleCards, currentCard) {
    var idx = -1;
    for (var i = 0; i < visibleCards.length; i++) {
      if (visibleCards[i] === currentCard) { idx = i; break; }
    }

    var prevCard = idx > 0 ? visibleCards[idx - 1] : null;
    var nextCard = idx < visibleCards.length - 1 ? visibleCards[idx + 1] : null;

    var html = '<div class="msc-otr__overlay-nav">';
    if (prevCard) {
      html += '<button class="msc-otr__overlay-nav-btn msc-otr__overlay-nav-btn--prev" data-nav-prev data-nav-id="' + escapeAttr(prevCard.getAttribute('data-rider-id')) + '">';
      html += '<span class="msc-otr__overlay-nav-arrow">\u2190</span>';
      html += '<span class="msc-otr__overlay-nav-meta">';
      html += '<span class="msc-otr__overlay-nav-label">Previous</span>';
      html += '<span class="msc-otr__overlay-nav-name">' + escapeHtml(prevCard.getAttribute('data-name')) + '</span>';
      html += '</span>';
      html += '</button>';
    } else {
      html += '<div></div>';
    }
    html += '<div class="msc-otr__overlay-nav-pos">' + (idx + 1) + ' / ' + visibleCards.length + '</div>';
    if (nextCard) {
      html += '<button class="msc-otr__overlay-nav-btn msc-otr__overlay-nav-btn--next" data-nav-next data-nav-id="' + escapeAttr(nextCard.getAttribute('data-rider-id')) + '">';
      html += '<span class="msc-otr__overlay-nav-meta">';
      html += '<span class="msc-otr__overlay-nav-label">Next</span>';
      html += '<span class="msc-otr__overlay-nav-name">' + escapeHtml(nextCard.getAttribute('data-name')) + '</span>';
      html += '</span>';
      html += '<span class="msc-otr__overlay-nav-arrow">\u2192</span>';
      html += '</button>';
    } else {
      html += '<div></div>';
    }
    html += '</div>';
    return html;
  }

  function openOverlay(card) {
    if (overlayEl) closeOverlayImmediate();

    previousFocus = document.activeElement;

    var visibleCards = getVisibleCards();

    // Build overlay DOM
    overlayEl = document.createElement('div');
    overlayEl.className = 'msc-otr__overlay';
    overlayEl.setAttribute('role', 'dialog');
    overlayEl.setAttribute('aria-modal', 'true');
    overlayEl.setAttribute('aria-label', (card.getAttribute('data-name') || 'Rider') + ' profile');

    var panel = document.createElement('div');
    panel.className = 'msc-otr__overlay-panel';
    panel.innerHTML = buildOverlayHtml(card) + buildNavHtml(visibleCards, card);

    overlayEl.appendChild(panel);
    document.body.appendChild(overlayEl);

    // Hash routing
    updateHash(card);

    // Trigger transition
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlayEl.classList.add('is-active');
      });
    });

    document.body.style.overflow = 'hidden';
    panel.focus();
    animateOverlayStats(panel);

    // Scroll-driven effects
    initOverlayScroll(panel);

    // Bind close
    overlayEl.addEventListener('click', function (e) {
      if (e.target === overlayEl) closeOverlay();
    });

    panel.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('[data-overlay-close]');
      if (closeBtn) { closeOverlay(); return; }

      var navBtn = e.target.closest('[data-nav-prev], [data-nav-next]');
      if (navBtn) {
        var navId = navBtn.getAttribute('data-nav-id');
        var navCard = findCardById(navId);
        if (navCard) navigateOverlay(navCard);
        return;
      }

      // Gallery thumbnail clicks
      var thumbBtn = e.target.closest('[data-gallery-idx]');
      if (thumbBtn) {
        var mainImg = panel.querySelector('[data-gallery-main]');
        var allThumbs = panel.querySelectorAll('.msc-otr__overlay-gallery-thumb');
        if (mainImg) {
          mainImg.src = thumbBtn.getAttribute('data-gallery-src');
          allThumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumbBtn.classList.add('is-active');
        }
        return;
      }

      // Tab switching
      var tabBtn = e.target.closest('[data-tab-target]');
      if (tabBtn) {
        var target = tabBtn.getAttribute('data-tab-target');
        var allBtns = panel.querySelectorAll('.msc-otr__overlay-tab-btn');
        var allTabs = panel.querySelectorAll('.msc-otr__overlay-tab');
        allBtns.forEach(function (b) { b.classList.remove('is-active'); });
        allTabs.forEach(function (t) { t.classList.remove('is-active'); });
        tabBtn.classList.add('is-active');
        allTabs.forEach(function (t) {
          if (t.getAttribute('data-tab') === target) t.classList.add('is-active');
        });
        return;
      }

      // Video play button
      var playBtn = e.target.closest('[data-play-video]');
      if (playBtn) {
        var embedWrap = playBtn.closest('.msc-otr__overlay-video-embed');
        if (embedWrap) {
          var vidId = embedWrap.getAttribute('data-video-id');
          if (vidId) {
            embedWrap.innerHTML = '<iframe src="https://www.youtube.com/embed/' + vidId + '?autoplay=1&rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width:100%;height:100%;position:absolute;inset:0"></iframe>';
            embedWrap.style.position = 'relative';
          }
        }
        return;
      }
    });
  }

  function navigateOverlay(card) {
    if (!overlayEl) return;
    var panel = overlayEl.querySelector('.msc-otr__overlay-panel');
    if (!panel) return;

    var visibleCards = getVisibleCards();
    panel.innerHTML = buildOverlayHtml(card) + buildNavHtml(visibleCards, card);

    // Reset to Stats tab
    var allBtns = panel.querySelectorAll('.msc-otr__overlay-tab-btn');
    var allTabs = panel.querySelectorAll('.msc-otr__overlay-tab');
    allBtns.forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-tab-target') === 'stats');
    });
    allTabs.forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-tab') === 'stats');
    });

    panel.scrollTop = 0;
    animateOverlayStats(panel);

    // Update hash for navigated rider
    replaceHash(card);

    overlayEl.setAttribute('aria-label', (card.getAttribute('data-name') || 'Rider') + ' profile');

    initOverlayScroll(panel);
  }

  function closeOverlay() {
    if (!overlayEl) return;
    overlayEl.classList.remove('is-active');
    var el = overlayEl;
    setTimeout(function () {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    }, 600);
    overlayEl = null;
    document.body.style.overflow = '';
    // Clear hash
    clearHash();
    if (previousFocus) {
      previousFocus.focus();
      previousFocus = null;
    }
  }

  function closeOverlayImmediate() {
    if (!overlayEl) return;
    if (overlayEl.parentNode) overlayEl.parentNode.removeChild(overlayEl);
    overlayEl = null;
    document.body.style.overflow = '';
  }

  function initOverlayScroll(panel) {
    if (reducedMotion) return;

    var heroBg = panel.querySelector('[data-parallax-bg]');
    var heroInfo = panel.querySelector('[data-parallax-info]');
    var statsBar = panel.querySelector('[data-stats-bar]');

    panel.addEventListener('scroll', function () {
      var scrollTop = panel.scrollTop;

      if (heroBg) {
        var parallax = Math.min(scrollTop * 0.4, 120);
        heroBg.style.transform = 'translateY(' + parallax + 'px)';
      }

      if (heroInfo) {
        var opacity = Math.max(0, 1 - scrollTop / 400);
        var infoShift = Math.min(scrollTop * 0.4, 120) * 0.2;
        heroInfo.style.opacity = opacity;
        heroInfo.style.transform = 'translateY(' + (-infoShift) + 'px)';
      }

      if (statsBar) {
        var reveal = Math.min(1, Math.max(0, (scrollTop - 50) / 200));
        statsBar.style.opacity = reveal;
        statsBar.style.transform = 'translateY(' + (20 * (1 - reveal)) + 'px)';
      }
    }, { passive: true });
  }

  function initOverlay() {
    // Click on rider cards
    root.addEventListener('click', function (e) {
      var card = e.target.closest(CARD_SEL);
      if (card) { openOverlay(card); return; }

      // Click on stock entries or spotlight CTA
      var openTrigger = e.target.closest('[data-open-rider]');
      if (openTrigger) {
        var riderId = openTrigger.getAttribute('data-open-rider');
        var targetCard = findCardById(riderId);
        if (targetCard) openOverlay(targetCard);
      }
    });
  }

  // ── MODULE 4: HERO PARALLAX ───────────────────────────────────────────

  function initHeroParallax() {
    if (reducedMotion) return;

    var heroBg = root.querySelector('.msc-otr__hero-bg-img');
    var heroContent = root.querySelector('.msc-otr__hero-content');
    var scrollHint = root.querySelector('.msc-otr__scroll-hint');

    if (!heroBg && !heroContent) return;

    /* Use ScrollSmoother's smoothed scroll position when available.
       Raw pageYOffset jumps ahead of the smoothed page position,
       creating a per-frame disconnect visible as jitter. */
    function getSmoothedScroll() {
      if (window.MSCScroll && window.MSCScroll.smoother) {
        return window.MSCScroll.smoother.scrollTop();
      }
      return window.pageYOffset || 0;
    }

    window.addEventListener('scroll', function () {
      var scrollTop = getSmoothedScroll();

      if (heroBg) {
        var parallax = Math.min(scrollTop * 0.4, 200);
        heroBg.style.transform = 'translateY(' + parallax + 'px)';
      }

      if (heroContent) {
        var opacity = Math.max(0, 1 - scrollTop / 400);
        heroContent.style.opacity = opacity;
      }

      if (scrollHint) {
        var hintOpacity = Math.max(0, 1 - scrollTop / 300);
        scrollHint.style.opacity = hintOpacity * 0.4;
      }
    }, { passive: true });
  }

  // ── MODULE 5: STATS COUNT-UP ──────────────────────────────────────────

  function initStatsCountUp() {
    var statsSection = root.querySelector('.msc-otr__stats');
    if (!statsSection) return;

    var values = statsSection.querySelectorAll('[data-count-target]');
    if (values.length === 0) return;

    var animated = false;

    function animateValues() {
      if (animated) return;
      animated = true;

      values.forEach(function (el) {
        var target = parseInt(el.getAttribute('data-count-target'), 10);
        if (isNaN(target)) { el.textContent = el.getAttribute('data-count-target'); return; }

        var start = 0;
        var duration = 1500;
        var startTime = null;

        function step(timestamp) {
          if (!startTime) startTime = timestamp;
          var progress = Math.min((timestamp - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(start + (target - start) * eased);
          if (progress < 1) requestAnimationFrame(step);
        }

        requestAnimationFrame(step);
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateValues();
            observer.disconnect();
          }
        });
      }, { threshold: 0.3 });
      observer.observe(statsSection);
    } else {
      animateValues();
    }
  }

  // ── MODULE 6: SCROLL REVEAL ───────────────────────────────────────────

  function initScrollReveal() {
    var revealEls = root.querySelectorAll('.msc-otr__reveal');
    if (revealEls.length === 0) return;

    if (reducedMotion) {
      revealEls.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      revealEls.forEach(function (el) { observer.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-revealed'); });
    }
  }

  // ── MODULE 7: KEYBOARD ────────────────────────────────────────────────

  function initKeyboard() {
    document.addEventListener('keydown', function (e) {
      // ESC closes overlay
      if (e.key === 'Escape' && overlayEl) {
        closeOverlay();
        return;
      }

      // Enter/Space on cards opens overlay
      if ((e.key === 'Enter' || e.key === ' ') && e.target.closest(CARD_SEL)) {
        e.preventDefault();
        var card = e.target.closest(CARD_SEL);
        openOverlay(card);
        return;
      }

      // Enter/Space on stock entries
      if ((e.key === 'Enter' || e.key === ' ') && e.target.closest('[data-open-rider]')) {
        e.preventDefault();
        var trigger = e.target.closest('[data-open-rider]');
        var riderId = trigger.getAttribute('data-open-rider');
        var targetCard = findCardById(riderId);
        if (targetCard) openOverlay(targetCard);
        return;
      }

      // Arrow keys for overlay nav
      if (overlayEl && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
        var panel = overlayEl.querySelector('.msc-otr__overlay-panel');
        if (!panel) return;
        var navSel = e.key === 'ArrowLeft' ? '[data-nav-prev]' : '[data-nav-next]';
        var navBtn = panel.querySelector(navSel);
        if (navBtn) {
          var navId = navBtn.getAttribute('data-nav-id');
          var navCard = findCardById(navId);
          if (navCard) navigateOverlay(navCard);
        }
        return;
      }

      // Tab trap within overlay
      if (e.key === 'Tab' && overlayEl) {
        var panel = overlayEl.querySelector('.msc-otr__overlay-panel');
        if (!panel) return;
        var focusable = panel.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])');
        if (focusable.length === 0) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first || !panel.contains(document.activeElement)) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last || !panel.contains(document.activeElement)) {
            e.preventDefault();
            first.focus();
          }
        }
      }
    });
  }

  // ── MODULE 8: HASH ROUTING ─────────────────────────────────────────────

  function slugify(name) {
    return (name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function updateHash(card) {
    if (!card) return;
    var name = card.getAttribute('data-name');
    var slug = slugify(name);
    if (slug) {
      history.pushState(
        { riderId: card.getAttribute('data-rider-id'), riderSlug: slug },
        '',
        '#rider-' + slug
      );
    }
  }

  function replaceHash(card) {
    if (!card) return;
    var name = card.getAttribute('data-name');
    var slug = slugify(name);
    if (slug) {
      history.replaceState(
        { riderId: card.getAttribute('data-rider-id'), riderSlug: slug },
        '',
        '#rider-' + slug
      );
    }
  }

  function clearHash() {
    if (window.location.hash.indexOf('#rider-') === 0) {
      history.pushState({}, '', window.location.pathname + window.location.search);
    }
  }

  function openRiderFromHash() {
    var hash = window.location.hash;
    if (!hash || hash.indexOf('#rider-') !== 0) return;
    var targetSlug = hash.substring(7);

    var cards = root.querySelectorAll(CARD_SEL);
    for (var i = 0; i < cards.length; i++) {
      var cardSlug = slugify(cards[i].getAttribute('data-name'));
      if (cardSlug === targetSlug) {
        // Delay to ensure DOM is ready
        var targetCard = cards[i];
        setTimeout(function () { openOverlay(targetCard); }, 400);
        return;
      }
    }
  }

  function initHashRouting() {
    // Check for deep link on page load
    openRiderFromHash();

    // Handle browser back/forward
    window.addEventListener('popstate', function (e) {
      if (window.location.hash.indexOf('#rider-') === 0) {
        openRiderFromHash();
      } else if (overlayEl) {
        closeOverlayImmediate();
        document.body.style.overflow = '';
        if (previousFocus) {
          previousFocus.focus();
          previousFocus = null;
        }
      }
    });
  }

  // ── MODULE 9: OVERLAY STATS COUNT-UP ───────────────────────────────────

  function animateOverlayStats(panel) {
    if (reducedMotion) return;

    var statValues = panel.querySelectorAll('.msc-otr__overlay-stat-value');
    statValues.forEach(function (el) {
      var text = el.textContent.trim();
      // Only animate pure numbers or numbers with # prefix
      var numMatch = text.match(/^#?(\d+)$/);
      if (!numMatch) return;

      var prefix = text.startsWith('#') ? '#' : '';
      var target = parseInt(numMatch[1], 10);
      if (isNaN(target) || target === 0) return;

      el.textContent = prefix + '0';
      var duration = 1200;
      var startTime = null;

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
        el.textContent = prefix + Math.round(target * eased);
        if (progress < 1) requestAnimationFrame(step);
      }

      requestAnimationFrame(step);
    });
  }

  // ── BOOT ──────────────────────────────────────────────────────────────

  function init() {
    initFilters();
    initCards();
    initOverlay();
    initHeroParallax();
    initStatsCountUp();
    initScrollReveal();
    initKeyboard();
    initHashRouting();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
